import { CSSProperties } from "react";
import styled from "styled-components";
import theme from "styles/theme";

export const DocumentDescription = styled.span`
  font-size: ${(props) => props.theme["@small-font-size"]};
  color: ${(props) => props.theme["@color-neutral-400"]};
`;

export const DocumentType = styled.h1`
  font-size: ${(props) => props.theme["@small-font-size"]};
  color: ${(props) => props.theme["@color-neutral-500"]};
  margin: 8px 0 5px 0;
`;

export const VehiclePlateTag: CSSProperties = {
  fontSize: theme["@small-font-size"],
  fontWeight: theme["@normal-font-weight"],
  color: theme.colors.text,
  borderRadius: "10px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginRight: "82px",
  width: "88px",
};

export const CloseDrawer = styled.span`
  .closeIcon > svg {
    color: ${(props) => props.theme["@input-border-color"]} !important;
    cursor: pointer !important;
    :hover {
      color: ${(props) => props.theme.colors.text} !important;
    }
  }
`;

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: auto 0.1fr;
  align-items: center;
`;

export const TitleContainer = styled.div`
  display: grid;
  grid-template-columns: 0.1fr 1fr;
  column-gap: 12px;
  align-items: center;
`;

export const DocumentContainer = styled.div`
  max-width: 335px;
  max-height: 350px;
  overflow: auto;
  margin-top: 15px;
`;

export const Title = styled.h1`
  font-size: ${(props) => props.theme["@large-font-size"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  margin-bottom: 1px;
`;

export const MenuItem: CSSProperties = {
  backgroundColor: theme["@default-background"],
  cursor: "default",
  padding: "8px 12px",
};

export const Menu: CSSProperties = {
  width: "360px",
};
